import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  & .sub-line {
    padding-left: 10vw;
  }
  & .submitButton {
    & .hefesto-button {
      width: 100%;
    }
    text-align: center;
  }
  & .bold {
    font-weight: bold;
  }
`;

export const Keyvalue = styled.div`
  display: flex;
  flex-direction: row;
  text-align: left;
  justify-content: space-between;
  padding: 1rem 1rem;
  & .sub-keys {
    text-align: right;
    justify-content: space-around;
  }
  & .values {
    text-align: right;
  }
`;
